import { Dialog } from '@servicetitan/anvil2';
import { SetupDataStore, useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { providerIdToName } from '@servicetitan/financing-utils-shared';

interface ExternalApplicationHeaderProps {
    onCancel?: () => void;
}

export const ExternalApplicationHeader = ({ onCancel }: ExternalApplicationHeaderProps = {}) => {
    const { setupData } = SetupDataStore.useStore();
    const { applicationDialogHeading } = useProviderConfig();

    return (
        <Dialog.Header>
            {onCancel && <Dialog.CancelButton onClick={onCancel} />}
            {setupData?.provider && applicationDialogHeading
                ? applicationDialogHeading
                : `${providerIdToName(setupData?.provider ?? '')} Application`}
        </Dialog.Header>
    );
};
